import React, {useEffect, useState} from "react"

import "./MyPage.css"
import iconBack from "../../assets/iconBack.svg"

import MyNav from "../../component/Nav/MyNav"
import RightFooter from "../../component/Footer/RightFooter"
import {retrieveData, sendRequest, storeData, validatePhone} from "../../common";

function MyModify() {

	const [user, setUser] = useState()
	const [email, setEmail] = useState(user?.email)
	const [name, setName] = useState(user?.name)
	const [gender, setGender] = useState(user?.gender)
	const [birth, setBirth] = useState(user?.birth)
	const [phone, setPhone] = useState(user?.phone)
	const [receiptEmail, setReceiptEmail] = useState(user?.receiptEmail)
	const [password, setPassword] = useState()
	const [passwordConfirm, setPasswordConfirm] = useState()
	const [organization, setOrganization] = useState(user?.organization)
	const [inquiryPhone, setInquiryPhone] = useState(user?.inquiryPhone)

	// useEffect(() => {
	// 	setName(user?.name)
	// }, [user])


	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
			setGender(user?.gender)
		})
	}, [])

	const editUser = (e) => {
		e.preventDefault()

		if (password?.length) {
			if (passwordConfirm?.length < 6 || password !== passwordConfirm) {
				alert('변경할 비밀번호를 확인해 주세요.')
				return
			}
		}

		sendRequest(`accounts/user/${user?.id}/`, 'PUT', {
			email,
			name,
			gender: gender === "성별을 선택해주세요" ? null : gender,
			birth,
			phone,
			receiptEmail,
			password,
			passwordConfirm,
			organization,
			inquiryPhone
		}, data => {
			setUser(data)
			storeData('user', data)
			alert('올바르게 수정되었습니다.')
		}, (data, code) => {
			if (data?.msg?.indexOf('email') !== -1) {
				alert('이메일이 중복 됩니다.')
			}
		})
	}

	return (
		<>
			<MyNav />
			<div className="container">
				<div className="myContent">
					<div className="header">
						<button type="button">
							<img src={iconBack} alt="뒤로가기" />
						</button>
						<h3>개인정보 수정</h3>
					</div>
					<div className="myWrap">
						<section className="myModify">
							<form name="myModify">
								<div className="formFlex">
									<div className="formWrap">
										<div className="formItem">
											<div className="formHead">
												<span className="formName">이메일 계정</span>
											</div>
										</div>
										<div className="formItem">
											<div className="formBody">
												<span>
													<input type="text" name="" defaultValue={user?.email} required onChange={e => setEmail(e.target.value)}/>
												</span>
											</div>
										</div>
									</div>
									<div className="formWrap">
										<div className="formItem">
											<div className="formHead">
												<span className="formName">이름</span>
											</div>
										</div>
										<div className="formItem">
											<div className="formBody">
												<span>
													<input type="text" name="" defaultValue={user?.name} required onChange={e => setName(e.target.value)} />
												</span>
											</div>
										</div>
									</div>
									<div className="formWrap">
										<div className="formItem">
											<div className="formHead">
												<span className="formName">성별</span>
											</div>
										</div>
										<div className="formItem">
											<div className="formBody">
												<span className="selectWrap">
													<select name="" value={gender} onChange={e => setGender(e.target.value)}>
														<option defaultValue="">성별을 선택해주세요</option>
														<option defaultValue="여성">여성</option>
														<option defaultValue="남성">남성</option>
													</select>
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="formFlex">
									<div className="formWrap">
										<div className="formItem">
											<div className="formHead">
												<span className="formName">생년월일</span>
											</div>
										</div>
										<div className="formItem">
											<div className="formBody">
												<span>
													<input type="text" name="" defaultValue={user?.birth} required onChange={e => setBirth(e.target.value)} maxLength={8}/>
												</span>
											</div>
										</div>
									</div>
									<div className="formWrap">
										<div className="formItem">
											<div className="formHead">
												<span className="formName">휴대폰 번호</span>
											</div>
										</div>
										<div className="formItem">
											<div className="formBody">
												<span>
													<input type="text" name="" defaultValue={user?.phone} required onChange={e => setPhone(e.target.value)} onBlur={() => validatePhone(phone, setPhone)} maxLength={12}/>
												</span>
											</div>
										</div>
									</div>
									<div className="formWrap">
										<div className="formItem">
											<div className="formHead">
												<span className="formName">수신 이메일</span>
											</div>
										</div>
										<div className="formItem">
											<div className="formBody">
												<span>
													<input type="text" name="" defaultValue={user?.receiptEmail} required onChange={e => setReceiptEmail(e.target.value)} />
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="formFlex">
									<div className="formWrap">
										<div className="formItem">
											<div className="formHead">
												<span className="formName">비밀번호 변경</span>
											</div>
										</div>
										<div className="formItem">
											<div className="formBody">
												<span>
													<input type="password" name="" placeholder="변경할 비밀번호를 입력해주세요" required onChange={e => setPassword(e.target.value)} />
												</span>
											</div>
										</div>
									</div>
									<div className="formWrap">
										<div className="formItem">
											<div className="formHead">
												<span className="formName">비밀번호 확인</span>
											</div>
										</div>
										<div className="formItem">
											<div className="formBody">
												<span>
													<input type="password" name="" placeholder="변경할 비밀번호를 다시 입력해주세요" required onChange={e => setPasswordConfirm(e.target.value)} />
												</span>
											</div>
										</div>
									</div>
									<div className="formWrap">
										<div className="formItem">
											<div className="formHead">
												<span className="formName">기본 발급기관</span>
											</div>
										</div>
										<div className="formItem">
											<div className="formBody">
												<span>
													<input type="text" name="" defaultValue={user?.organization} required onChange={e => setOrganization(e.target.value)}/>
												</span>
											</div>
										</div>
									</div>
								</div>
								<div className="formFlex">
									<div className="formWrap">
										<div className="formItem">
											<div className="formHead">
												<span className="formName">기본 문의처</span>
											</div>
										</div>
										<div className="formItem">
											<div className="formBody">
													<span>
														<input type="text" name="" defaultValue={user?.inquiryPhone} required onChange={e => setInquiryPhone(e.target.value)}/>
													</span>
											</div>
										</div>
									</div>
									<div className="formWrap">
										<div className="formHead">
											<span className="formName">관리자가 부여한 인증코드 발송 권한 수</span>
										</div>
										<div className="formItem">
											심리유형검사(개인) {user?.coin1}개
										</div>
										<div className="formItem" style={{marginTop: 10}}>
											심리유형검사(단체) {user?.coin2}개
										</div>
										<div className="formItem" style={{marginTop: 10}}>
											도형심리검사(개인) {user?.coin3}개
										</div>
										<div className="formItem" style={{marginTop: 10}}>
											도형심리검사(단체) {user?.coin4}개
										</div>
									</div>
								</div>
								<div className="myBtnWrap">
									<button type="button">취소</button>
									<button type="button" className="keyBtn" onClick={editUser}>
									저장
									</button>
								</div>
							</form>
						</section>
					</div>
				</div>
			</div>
			<RightFooter />
		</>
	)
}

export default MyModify
